// src/hooks/useRole.js
import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../firebase";

export default function useRole() {
  const [role, setRole] = useState(null);
  const [loadingRole, setLoadingRole] = useState(true);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (!user) {
        setRole(null);
        setLoadingRole(false);
        return;
      }

      try {
        const ref = doc(db, "users", user.uid);
        const snap = await getDoc(ref);

        if (snap.exists()) {
          setRole(snap.data().role || "staff");
        } else {
          setRole("staff"); // fallback
        }
      } catch (err) {
        console.error("Error loading role:", err);
        setRole("staff");
      }

      setLoadingRole(false);
    });

    return () => unsubscribe();
  }, []);

  // -----------------------------
  // 🔥 ROLE-BASED PERMISSIONS
  // -----------------------------

  const isSuperAdmin = role === "superadmin";
  const isAdmin = role === "admin";
  const isStaff = role === "staff";

  return {
    role,
    loadingRole,

    // 👉 SUPERADMIN: full access
    // 👉 ADMIN: add + edit
    // 👉 STAFF: read-only

    canAdd: isSuperAdmin || isAdmin,
    canEdit: isSuperAdmin || isAdmin,
    canDelete: isSuperAdmin,
    isSuperAdmin,
    isAdmin,
    isStaff,
  };
}
